// extracted by mini-css-extract-plugin
export var footer = "_ox-5";
export var fulfillmentInput = "_ox-0";
export var shipDateInput = "_ox-1";
export var shipmentModal = "_ox-2";
export var shipmentModalContent = "_ox-3";
export var tableContainer = "_ox-4";